import { createStore, applyMiddleware } from 'redux';
import { composeWithDevTools } from 'redux-devtools-extension';

import { sagaMiddleware } from './sagas';
import reducers from './reducers';

const store = createStore(reducers, composeWithDevTools(applyMiddleware(sagaMiddleware)));

export default store;
